<template>
  <b-badge pill :variant="v.variant" class="mb-auto px-3 py-1">{{ v.text }}</b-badge>
</template>

<script>
export default {
  name: "offer-pill",
  props: {
    offer: Object
  },
  computed: {
    v() {
      if (this.offer.status == 'D') {
        const variants = {
          A: 'success',
          D: 'danger',
          C: 'secondary'
        }
        return {
          variant: variants[this.offer.result],
          text: this.offer.long_result
        }
      } else if (this.offer.needs_buyer_action) {
        return {
          variant: 'primary',
          text: 'Waiting Buyer'
        }
      } else if (this.offer.needs_seller_action) {
        return {
          variant: 'warning',
          text: 'Needs Response'
        }
      }
    },
  }
}
</script>

<style scoped>

</style>